<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      下梅林站<br>
站点介绍<br>
下梅林站位于梅丽路与梅林路交汇路口以东的梅林路下，西接梅景站，东接梅村站。车站设有5个出入口(A、B1、B2、C、D)，布置于梅林路两侧，东侧是金梅花园，南侧是梅林水库，西侧是深圳市梅林小学，北侧是下梅林文体公园。车站以白色为主色调，柱体采用深绿色搪瓷钢板，柱子上方加入客家围屋古建筑的元素符号，为车站赋予了浓厚的文化气息。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:10	23:27	9号线	3分50秒	5分55秒<br>
文锦	06:32	23:42	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:08	23:27	9号线	4分25秒	5分55秒<br>
文锦	06:32	23:42	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:04	00:27	9号线	4分钟	5分55秒<br>
文锦	06:31	00:42	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
河背村、梅丽路南侧、梅华路、梅林路南侧（西）、富盛花园<br><br>
B1出入口:<br>
梅林路南侧（东）、星林巷<br><br>
B2出入口:<br>
金梅花园、深圳市福田区梅林小学、宏安花园、梅林二村、碧荔花园、梅林中学<br><br>
C出入口:<br>
梅亭路、润裕花园、下梅林文体公园、梅林路北侧（东）、润华苑<br><br>
D出入口:<br>
梅林一村、梅林路北侧（西）、梅丽路北侧、梅林水库、家乐福<br><br>
公交换乘信息<br><br>
B1出入口:<br>
公交站名： 梅林一村<br>
N9路、44路、45路、60路、67路、201路、M204路、M312路、324路、334路、M460路、B912路、216<br><br>
C出入口:<br>
公交站名： 梅林一村1<br>
201路、222路、334路、67路、M204路、M312路、M460路、N6、N12、B912、44、324、216<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>